import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, message, Result, Spin, Timeline } from 'antd';
import Moment from 'react-moment';
import { IEleccion } from '../../../../../interfaces/elecciones/eleccion';
import {
  CheckCircleOutlined,
  FieldTimeOutlined,
  HourglassOutlined,
  LikeOutlined
} from '@ant-design/icons';
import { IResponse } from '../../../../../interfaces/response';
import eleccionesProvider from '../../../../../services/eleccionesProvider';
import 'moment/locale/es';
import './eleccionvigente.css';

const moment = require('moment');

const EleccionVigente = (props) => {
  const [guardando, setguardando] = useState(false);
  const e: IEleccion = props.eleccion;

  const iniciarProceso = async () => {
    setguardando(true);
    e.eleccion.inicioVotacion = true;
    const res: any = await eleccionesProvider.guardarEleccion(e.eleccion);
    //TODO VALIDAR
    if (res.succeeded) {
      message.success(res.message);
    } else {
      message.warning(res.message);
    }
    setguardando(false);
  };

  const cerrarProceso = async () => {
    message.warning(
      `El cierre se realizará de forma automatica a las ${moment(e.eleccion.horaFinLocal).format(
        'LLL'
      )}`
    );
  };

  return (
    <div>
      {e && (
        <Spin spinning={guardando}>
          <h3 className='text-center'>Elección vigente: {e.eleccion.nombre}</h3>
          <p className='text-center fw-light'>
            <strong>Se registro la eleccion:</strong>{' '}
            <Moment locale={'es'} format={'DD/MM/YYYY hh:mm A'}>
              {e.eleccion.fechaReg}
            </Moment>
          </p>
          <p className='text-center fw-light'>
            <strong>Finaliza proceso de elecciones:</strong>{' '}
            <Moment locale={'es'} format={'DD/MM/YYYY hh:mm A'}>
              {e.eleccion.horaFinLocal}
            </Moment>
          </p>
          <Card>
            <Timeline pending='Se cierra el proceso...' mode={'alternate'} reverse={false}>
              <Timeline.Item color={'green'}>
                <div style={{ opacity: 0.8 }} className='date w-100 mb-2'>
                  <Moment locale={'es'} format={'DD/MM/YYYY'}>
                    {e.eleccion.periodoIni}
                  </Moment>
                </div>
                <span className='primary-text mb-4'>
                  <strong>Se inicio el proceso de elecciones.</strong>
                </span>
              </Timeline.Item>
              <Timeline.Item color={e.eleccion.configuroPostulantes ? 'green' : 'blue'}>
                <div style={{ opacity: 0.8 }} className='date w-100 mb-2'>
                  {e.eleccion.lineaTiempoPostulantes ? (
                    <Moment locale={'es'} format={'DD/MM/YYYY hh:mm A'}>
                      {e.eleccion.lineaTiempoPostulantes}
                    </Moment>
                  ) : (
                    '--'
                  )}
                </div>
                <span className='primary-text mb-4'>
                  <strong>Se configuraron los Postulantes.</strong>
                </span>
              </Timeline.Item>
              <Timeline.Item color={e.eleccion.configuroElectores ? 'green' : 'blue'}>
                <div style={{ opacity: 0.8 }} className='date w-100 mb-2'>
                  {e.eleccion.lineaTiempoElectores ? (
                    <Moment locale={'es'} format={'DD/MM/YYYY hh:mm A'}>
                      {e.eleccion.lineaTiempoElectores}
                    </Moment>
                  ) : (
                    '--'
                  )}
                </div>
                <span className='primary-text mb-4'>
                  <strong>Se configuraron los Electores.</strong>
                </span>
              </Timeline.Item>
              <Timeline.Item
                color={e.eleccion.inicioVotacion ? 'green' : 'blue'}
                label={
                  e.eleccion.configuroPostulantes &&
                  e.eleccion.configuroElectores && (
                    <Button
                      htmlType={'button'}
                      disabled={e.eleccion.inicioVotacion}
                      type={'dashed'}
                      size={'small'}
                      onClick={iniciarProceso}
                    >
                      <LikeOutlined /> Iniciar
                    </Button>
                  )
                }
              >
                <div style={{ opacity: 0.8 }} className='date w-100 mb-2'>
                  {e.eleccion.lineaTiempoInicio ? (
                    <Moment locale={'es'} format={'DD/MM/YYYY hh:mm A'}>
                      {e.eleccion.lineaTiempoInicio}
                    </Moment>
                  ) : (
                    '--'
                  )}
                </div>
                <span className='primary-text mb-4'>
                  <strong>Se inicia el proceso de votación.</strong>
                </span>
              </Timeline.Item>
              <Timeline.Item
                color={e.eleccion.finVotacion ? 'green' : 'blue'}
                label={
                  e.eleccion.configuroPostulantes &&
                  e.eleccion.configuroElectores && (
                    <Button
                      htmlType={'button'}
                      disabled={e.eleccion.finVotacion}
                      type={'dashed'}
                      size={'small'}
                      onClick={cerrarProceso}
                    >
                      <FieldTimeOutlined />
                      {moment(e.eleccion.horaFinLocal).from()}
                    </Button>
                  )
                }
              >
                <div style={{ opacity: 0.8 }} className='date w-100 mb-2'>
                  {e.eleccion.horaFinLocal ? (
                    <Moment locale={'es'} format={'DD/MM/YYYY hh:mm A'}>
                      {e.eleccion.horaFinLocal}
                    </Moment>
                  ) : (
                    '--'
                  )}
                </div>
                <span className='primary-text mb-4'>
                  <strong>
                    Se cierra el proceso de votación (
                    <Moment locale={'es'} format={'hh:mm A'}>
                      {e.eleccion.horaFinLocal}
                    </Moment>
                    )
                  </strong>
                </span>
              </Timeline.Item>
              <Timeline.Item
                dot={e.eleccion.finVotacion ? <CheckCircleOutlined /> : <HourglassOutlined />}
              >
                <span className='primary-text mb-4'>
                  <strong>Se muestra los resultados.</strong>
                </span>
              </Timeline.Item>
            </Timeline>
          </Card>
        </Spin>
      )}
    </div>
  );
};

EleccionVigente.propTypes = {
  eleccion: PropTypes.object.isRequired
};

export default EleccionVigente;
